import React, { useCallback } from 'react';
import MediaSelector, { MediaSelectorProps } from '../../MediaPopup/MediaSelector';
import MediaManager, { MediaManagerProps } from '../../MediaPopup/MediaManager';

export interface Props {
  mediaSelectorProps: MediaSelectorProps | undefined;
  mediaManagerProps: MediaManagerProps | undefined;
  onSelect: (selected) => void;
  onManageDone: (selected) => void;
  setMediaSelectorProps: any;
  setMediaManagerProps: any;
}

/**
 * Contains all the related supporting components editor needs
 */
const EditorCommon: React.FC<Props> = ({
  mediaSelectorProps,
  onSelect,
  setMediaSelectorProps,
  mediaManagerProps,
  onManageDone,
  setMediaManagerProps,
}) => {
  const onClose = useCallback(() => {
    setMediaSelectorProps(undefined);
    onSelect([]);
  }, [onSelect, setMediaSelectorProps]);

  const onCloseManager = useCallback(() => {
    setMediaManagerProps(undefined);
    onManageDone([]);
  }, [onManageDone, setMediaManagerProps]);

  return (
    <>
      {mediaSelectorProps && (
        <MediaSelector {...mediaSelectorProps} onSelect={onSelect} onClose={onClose} />
      )}

      {mediaManagerProps && (
        <MediaManager {...mediaManagerProps} onDone={onManageDone} onClose={onCloseManager} />
      )}
    </>
  );
};
EditorCommon.displayName = 'EditorCommon';

export default EditorCommon;
